
class DataStore {
	#rooms = null;
	#messages = {};
	#db = null;
	#dbPromise = null;

	constructor() {}

	async #openDb() {
		if (this.#db) return this.#db;
		if (this.#dbPromise) return this.#dbPromise;

		this.#dbPromise = new Promise((resolve, reject) => {
			if (!('indexedDB' in window)) {
				resolve(null);
				return;
			}

			const request = window.indexedDB.open('driima-store', 1);

			request.onupgradeneeded = () => {
				const db = request.result;
				if (!db.objectStoreNames.contains('kv')) {
					db.createObjectStore('kv');
				}
			};

			request.onsuccess = () => {
				this.#db = request.result;
				resolve(this.#db);
			};

			request.onerror = () => reject(request.error);
		});

		return this.#dbPromise;
	}

	async #get(key) {
		const db = await this.#openDb();
		if (!db) return undefined;

		return new Promise((resolve, reject) => {
			const tx = db.transaction('kv', 'readonly');
			const request = tx.objectStore('kv').get(key);
			request.onsuccess = () => resolve(request.result);
			request.onerror = () => reject(request.error);
		});
	}

	async #put(key, value) {
		const db = await this.#openDb();
		if (!db) return;

		return new Promise((resolve, reject) => {
			const tx = db.transaction('kv', 'readwrite');
			tx.objectStore('kv').put(value, key);
			tx.oncomplete = () => resolve();
			tx.onerror = () => reject(tx.error);
		});
	}

	async #loadRooms() {
		if (this.#rooms != null) return this.#rooms;
		this.#rooms = (await this.#get('rooms')) ?? null;
		return this.#rooms;
	}

	async #loadMessages(roomId) {
		if (this.#messages[roomId] != undefined) return this.#messages[roomId];
		const content = (await this.#get(`messages:${roomId}`)) ?? null;
		if (content) this.#messages[roomId] = content;
		return content;
	}

	getRooms() {
		return this.#loadRooms();
	}

	putRooms(rooms) {
		this.#rooms = rooms;
		this.#put('rooms', rooms).catch(() => {});
	}

	getMessages(roomId) {
		return this.#loadMessages(roomId);
	}

	putMessages(content) {
		const roomId = content.roomInfo.id;
		const data = this.#messages[roomId];
		if (data == undefined) this.#messages[roomId] = content;
		else {
			content.messages.forEach((message) => {
				data.messages.push(message);
			});
		}
		this.#put(`messages:${roomId}`, this.#messages[roomId]).catch(() => {});
	}
}

const store = new DataStore();
export default store;
